module.exports = __webpack_public_path__ + "static/media/Sort.962f71e4.svg";